
import React from "react";
import "./VirasatV2DefaultHomePage.scss"
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const VirasatV2DefaultStoryPage = ({ components }) => {
    const dispatch = useDispatch()
    const getLeftComponent = (component) => {
        switch (component.ID) {
            case "VirsatDefaultStoryPage-since":
                return <div className="since-text-story">- {component?.Props?.text} -</div>

            case "VirsatDefaultStoryPage-header":
                return <div className="VirasatV2DefaultStoryPage-container-title">{component?.Props?.header}
                    <div className="VirasatV2DefaultStoryPage-container-title-story">{component?.Props?.highlightedHeader}</div></div>

            case "VirsatDefaultStoryPage-paragraph":
                return component?.Data?.map((text, key) => {
                    return (
                        <div className="VirasatV2DefaultStoryPage-container-text-cont" key={key}>
                            {text?.text}
                        </div>
                    )
                })
            case "VirsatDefaultStoryPage-button":
                return <div className="VirasatV2DefaultStoryPage-btn-cont">
                    <Button
                        text={component?.Props?.text}
                        isSecondary={true}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href !== "") {
                                if (component?.Props?.href?.includes("https://")) {
                                    window.open(component?.Props?.href, '_blank')
                                } else {
                                    window.location.href = component?.Props?.href && component?.Props?.href !== "" ? component?.Props?.href : "/"
                                }
                            }
                            else {
                                dispatch(setIsComing(true))
                            }
                        }}
                    />
                </div>
            default:
                return <div />
        }
    }
    const leftContent = (leftComponents) => {
        return (
            <div className="VirasatV2DefaultStoryPage-container-left">
                {sortByOrderAscending(leftComponents).map((component, key) => {
                    return (
                        getLeftComponent(component)
                    )
                })}

            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirsatDefaultStoryPage-left":
                return leftContent(component?.Components)
            case "VirsatDefaultStoryPage-icon":
                return <div className="VirasatV2DefaultStoryPage-container-icon">
                    <div className="VirasatV2DefaultStoryPage-container-icon-inner">
                        <img alt="" src={component?.Props?.icon} />
                    </div>

                </div>
            case "VirsatDefaultStoryPage-right":
                return <div className="VirasatV2DefaultStoryPage-container-right"
                    style={{ backgroundImage: `url(${component?.Props?.src})` }}>
                    <div className="VirasatV2DefaultStoryPage-container-right-inner" />
                </div>
            default:
                return <div />
        }

    }

    return (
        <div className="VirasatV2DefaultStoryPage" >
            <div className="VirasatV2DefaultStoryPage-container">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getComponents(component)
                    )
                })}
            </div>
        </div>
    )
}
export default VirasatV2DefaultStoryPage